module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('request-status', {
    attrs: {
      "request": _vm.requests.validate
    }
  }), _vm._v(" "), (_vm.properties && _vm.properties.id) ? _c('v-card-title', {
    staticClass: "subtitle-1 grey lighten-4 py-1"
  }, [_vm._v("\n    Validating " + _vm._s(_vm.properties.title) + "\n    "), _c('v-btn', {
    attrs: {
      "href": ("https://www.jotform.com/build/" + _vm.formId),
      "target": "_blank",
      "flat": "",
      "small": "",
      "icon": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close', _vm.formId)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "icon": "",
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.formId) ? _c('v-card-text', [(_vm.properties && _vm.properties.id) ? _c('form-checks', {
    attrs: {
      "has-relationship-id": _vm.hasRelationshipId,
      "webhook-key": _vm.webhookKey,
      "properties": _vm.properties
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("\n        Select fields which you would like to link to values in AppointmentGuru\n      ")]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "value": _vm.showRefreshNotice,
      "type": "info",
      "dismissible": ""
    }
  }, [_c('strong', [_vm._v("Important")]), _vm._v(" If you have this form open in JotForm you must refresh the page for changes to reflect\n      ")]), _vm._v(" "), _c('v-card', {
    staticClass: "grey lighten-3"
  }, [_c('v-card-text', {
    staticClass: "py-1"
  }, [_vm._v("\n          Map your form fields to your client's AppointmentGuru profile")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Field in AppointmentGuru")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Field in form")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  })], 1), _vm._v(" "), [_c('v-card', {
    staticClass: "mt-1"
  }, [_c('v-layout', [_c('v-flex', {
    staticClass: "pl-3 pt-2",
    attrs: {
      "xs6": ""
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agField),
      expression: "agField"
    }],
    staticClass: "mr-2",
    staticStyle: {
      "border": "solid 1px #ccc",
      "padding": "2px",
      "margin-top": "0px",
      "width": "90%"
    },
    attrs: {
      "placeholder": "Choose a field in AppointmentGuru"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.agField = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Choose a field in AppointmentGuru")]), _vm._v(" "), _vm._l((_vm.unmappedFields), function(field) {
    return _c('option', {
      key: field,
      attrs: {
        "disabled": field.startsWith('-- ')
      },
      domProps: {
        "value": field
      }
    }, [_vm._v("\n                      " + _vm._s(field) + "\n                    ")])
  })], 2)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.jfField),
      expression: "jfField"
    }],
    staticClass: "mr-2",
    staticStyle: {
      "border": "solid 1px #ccc",
      "padding": "2px",
      "margin-top": "7px",
      "width": "90%"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.jfField = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Choose a field from your form")]), _vm._v(" "), _vm._l((_vm.questions), function(question) {
    return [(!_vm.isHiddenJotFormFieldType(question)) ? [(_vm.isDisabledJotFormFieldType(question) !== false) ? _c('option', {
      key: question.qid,
      attrs: {
        "disabled": ""
      }
    }, [_vm._v("\n                          " + _vm._s(_vm.isDisabledJotFormFieldType(question)) + "\n                          ")]) : _c('option', {
      key: question.qid,
      domProps: {
        "value": question.qid
      }
    }, [(question.type === 'control_radio') ? _c('span', [_vm._v("()")]) : _vm._e(), _vm._v(" "), (question.type === 'control_checkbox') ? _c('span', [_vm._v("[]")]) : _vm._e(), _vm._v("\n                          " + _vm._s(question.text) + "\n                          "), (question.required === 'Yes') ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), (question.hidden === 'Yes') ? _c('span', [_vm._v("(hidden)")]) : _vm._e()])] : _vm._e()]
  })], 2)]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-2",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "block": "",
      "outline": "",
      "loading": _vm.requests.savequestion.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.saveQuestion
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)]], 2)], 1), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("These fields are mapped")]), _vm._v(" "), _vm._l((_vm.mappedFields), function(field) {
    return [_c('v-list-tile', {
      key: field.id
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      staticStyle: {
        "height": "30px",
        "line-height": "30px"
      }
    }, [_c('v-chip', {
      attrs: {
        "small": ""
      }
    }, [_c('v-avatar', [_c('img', {
      attrs: {
        "src": _vm.jotformIcon,
        "left": ""
      }
    })]), _vm._v(" "), (field.required === 'Yes') ? _c('span', {
      staticClass: "mr-1"
    }, [_vm._v("*")]) : _vm._e(), _vm._v("\n                " + _vm._s(field.text) + "\n              ")], 1), _vm._v(" "), _c('v-chip', {
      staticClass: "white",
      attrs: {
        "small": "",
        "flat": ""
      }
    }, [_c('v-icon', [_vm._v("arrow_right_alt")])], 1), _vm._v(" "), _c('v-chip', {
      attrs: {
        "small": ""
      }
    }, [_c('v-avatar', [_c('img', {
      attrs: {
        "src": _vm.agIcon,
        "left": ""
      }
    })]), _vm._v("\n                " + _vm._s(field.id) + "\n              ")], 1)], 1)], 1), _vm._v(" "), (field.required !== 'Yes') ? _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "flat": "",
        "small": "",
        "disabled": _vm.requests.savequestion.loading
      },
      on: {
        "click": function($event) {
          return _vm.requireQuestion(field)
        }
      }
    }, [_vm._v("Make required")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "flat": "",
        "small": "",
        "disabled": _vm.requests.savequestion.loading
      },
      on: {
        "click": function($event) {
          return _vm.unmap(field)
        }
      }
    }, [_vm._v("Unlink")])], 1)], 1)]
  })], 2) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.$emit('close', _vm.formId)
      }
    }
  }, [_vm._v("Done")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.refresh
    }
  }, [_vm._v("Revalidate form")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1286c00c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Integrations/JotForm/ValidateForm.vue
// module id = 1646
// module chunks = 0